import React, { useState } from "react";

import DropDownIcon from "@ancon/wildcat-ui/shared/icons/arrow-drop-down.svg";
import clsx from "clsx";

import styles from "./CartItem.module.scss";
import InteractiveDiv from "../support/InteractiveDiv";
import BodyText from "../support/BodyText";
import Button from "../support/Button";
import CartItemQuantityWidget from "./CartItemQuantityWidget";

export default function CartItem() {
  const [isModifyingQuantity] = useState(true);

  return (
    <>
      <InteractiveDiv
        className={clsx(styles.container, {
          [styles.selectedItemContainer]: isModifyingQuantity,
          [styles.container]: !isModifyingQuantity,
          [styles.hasItemStatus]: false,
        })}
        tabIndex={0}
      >
        <div
          className={clsx(styles.itemQuantity, {
            [styles.quantityText]: false,
          })}
        >
          <Button
            variant="secondary"
            className={styles.quantityButton}
            outlined
          >
            {2}
            <DropDownIcon />
          </Button>

          <CartItemQuantityWidget />
        </div>

        <div
          className={clsx(styles.itemDetailsContainer, {
            [styles.noModifications]: false,
          })}
        >
          <BodyText fontSize="1.6rem">Product Name</BodyText>
          <div>
            <BodyText color="body-2">Cheese</BodyText>
            <BodyText color="body-2">{`+ Sausages`}</BodyText>
            <BodyText color="body-2">{`- Ham`}</BodyText>
          </div>
        </div>
        <div className={styles.itemCost}>
          <BodyText className={styles.discountPrice}>10 kr</BodyText>

          <BodyText fontSize="1.6rem">130 kr</BodyText>
        </div>
      </InteractiveDiv>
      <hr className={styles.separator} />
    </>
  );
}
